import { render } from "./worksheet.vue?vue&type=template&id=da40cd20&scoped=true&ts=true"
import script from "./worksheet.vue?vue&type=script&lang=ts"
export * from "./worksheet.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da40cd20"]])

export default __exports__